import { render, staticRenderFns } from "./InspectionCenter.vue?vue&type=template&id=55e27bca&scoped=true"
import script from "./InspectionCenter.vue?vue&type=script&lang=js"
export * from "./InspectionCenter.vue?vue&type=script&lang=js"
import style0 from "./InspectionCenter.vue?vue&type=style&index=0&id=55e27bca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e27bca",
  null
  
)

export default component.exports